import GlobalActions from 'store/redux/global'
import store from 'store'

export const emptyDialog = {
    children: '',
    id: '',
    title: '',
    actions: []
}

export const information = ({ buttonLabel, id, title, children }) => ({
    actions: [
        {
            label: buttonLabel,
            onClick: () => {
                if (store) store.dispatch(GlobalActions.closeDialog())
            },
            type: 'dismiss'
        }
    ],
    children,
    id,
    title,
    visible: true
})

export const confirmation = ({ onConfirmLabel, onConfirm, onDismissLabel, id, title, children }) => ({
    actions: [
        {
            label: onConfirmLabel,
            onClick: () => onConfirm(),
            type: 'confirm'
        },
        {
            label: onDismissLabel,
            onClick: () => {
                if (store) store.dispatch(GlobalActions.closeDialog())
            },
            type: 'dismiss'
        }
    ],
    id,
    title,
    visible: true,
    children
})



// WEBPACK FOOTER //
// src/utils/generators/dialog.js